module.exports = __webpack_public_path__ + "static/media/notifications_none.7b242733.svg";